<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div v-if="this.is_authorization === null" class="card-body">
        <div class="d-flex justify-content-center">authorization checking...</div>
      </div>
      <div v-if="this.is_authorization === 'N'" class="card-body">
        <div class="d-flex justify-content-center">You do not have authorization for this page</div>
      </div>

      <div v-if="this.is_authorization === 'Y'" class="card-body">

        <!-- Header -->
        <div class="card mb-4">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>🎉 สุ่มรายชื่อผู้สมัคร — {{ eventDetails.title }}</b></h5>
              <a :href="'/dashboard-organizer/' + this.$route.params.event_key" class="btn btn-outline-secondary">
                <vue-feather type="arrow-left" size="16"></vue-feather> กลับหน้ารายงาน
              </a>
            </div>
          </div>
        </div>

        <!-- Loading participants -->
        <div v-if="is_loading === 'Y'" class="d-flex justify-content-center py-5">
          <img style="width: 60px" src="../../assets/images/running_loading.svg" />
        </div>

        <div v-if="is_loading === 'N'">

          <!-- ตั้งค่าการสุ่ม -->
          <div class="card mb-4">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>ตั้งค่าการสุ่ม</b></h5>
                <div class="d-flex gap-2">
                  <button type="button" @click.prevent="$router.go(0)" class="btn btn-outline-secondary btn-sm">
                    <vue-feather type="refresh-cw" size="16"></vue-feather> รีเซ็ตการสุ่ม
                  </button>
                  <button type="button" @click.prevent="reset_lucky_draw()" :disabled="is_resetting" class="btn btn-danger btn-sm">
                    <vue-feather type="trash-2" size="16"></vue-feather> {{ is_resetting ? 'กำลังรีเซ็ต...' : 'รีเซ็ตการสุ่มทั้งหมด' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-3 align-items-end">
                <div class="col-md-3">
                  <label class="form-label">ประเภทผู้สมัคร (run_type)</label>
                  <select class="form-select" v-model="filter_run_type">
                    <option value="">ทั้งหมด ({{ all_paid_runners.length }})</option>
                    <option v-for="rt in run_types" :key="rt.name" :value="rt.name">{{ rt.name }} ({{ rt.count }})</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เพศ</label>
                  <select class="form-select" v-model="filter_sex">
                    <option value="">ทั้งหมด</option>
                    <option value="ชาย">ชาย</option>
                    <option value="หญิง">หญิง</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label">จำนวนรางวัล</label>
                  <input type="number" class="form-control" v-model.number="prize_count" min="1" max="100" />
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted">
                  ผู้สมัคร (สถานะ PAID) ที่ยังไม่ถูกสุ่ม:
                  <b>{{ eligible_pool.length }}</b> คน /
                  ทั้งหมด: <b>{{ all_paid_runners.length }}</b> คน
                </small>
              </div>
            </div>
          </div>

          <!-- ปุ่มสุ่ม + animation -->
          <div class="card mb-4">
            <div class="card-body text-center py-5">
              <!-- Rolling display -->
              <div class="lucky-draw-box mb-4" :class="{ 'is-rolling': is_rolling }">
                <div v-if="!is_rolling && current_winners.length === 0" class="lucky-draw-placeholder">
                  <vue-feather type="gift" size="48" class="text-muted"></vue-feather>
                  <div class="mt-2 text-muted">กดปุ่มสุ่มเพื่อเริ่ม</div>
                </div>
                <div v-if="is_rolling" class="lucky-draw-rolling">
                  <div class="rolling-name">{{ rolling_display }}</div>
                </div>
                <div v-if="!is_rolling && current_winners.length > 0" class="lucky-draw-winner w-100 px-3">
                  <div class="winner-label mb-3">🎊 ผู้โชคดี {{ current_winners.length }} คน </div>
                  <div class="winner-grid">
                    <div v-for="(w, i) in current_winners" :key="w.runner_id" class="winner-card">
                      <div class="winner-number">#{{ i + 1 }}</div>
                      <div class="winner-name-sm">{{ w.fname }} {{ w.lname }}</div>
                      <div class="winner-detail-sm">{{ w.run_type_name }} | {{ w.sex }}</div>
                    </div>
                  </div>
                  <div class="winner-prize mt-3">🏆 รางวัล</div>
                </div>
              </div>

              <button
                type="button"
                @click.prevent="start_draw()"
                :disabled="is_rolling || eligible_pool.length === 0"
                class="btn btn-primary btn-lg px-5"
              >
                <vue-feather type="shuffle" size="20"></vue-feather>
                {{ is_rolling ? 'กำลังสุ่ม...' : eligible_pool.length === 0 ? 'ไม่มีผู้เข้าร่วม' : 'สุ่มรายชื่อ' }}
              </button>
            </div>
          </div>

          <!-- รายชื่อผู้โชคดีที่สุ่มแล้ว -->
          <div class="card mb-4" v-if="winners.length > 0">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>🏆 รายชื่อผู้โชคดี ({{ winners.length }} คน)</b></h5>
              <div class="d-flex gap-2">
                  <button type="button" @click.prevent="save_lucky_draw()" :disabled="is_saving" class="btn btn-primary btn-sm">
                    <vue-feather type="save" size="16"></vue-feather> {{ is_saving ? 'กำลังบันทึก...' : 'บันทึกข้อมูลการสุ่ม' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ชื่อ-สกุล</th>
                    <th style="text-align: center">เพศ</th>
                    <th style="text-align: left">ประเภท</th>
                    <th style="text-align: center">เบอร์โทร</th>
                    <th style="text-align: left">รางวัล</th>
                    <!-- <th style="text-align: center">ลบ</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(w, index) in winners_paged" :key="w.runner_id">
                    <td style="text-align: center">{{ (winners_page - 1) * page_size + index + 1 }}</td>
                    <td>{{ w.fname }} {{ w.lname }}</td>
                    <td style="text-align: center">{{ w.sex }}</td>
                    <td>{{ w.run_type_name }}</td>
                    <td style="text-align: center">{{ mask_phone(w.mobile_no) }}</td>
                    <td>{{ w.prize_name }}</td>
                    <!-- <td style="text-align: center">
                      <button type="button" disabled class="btn btn-sm btn-outline-danger">
                        <vue-feather type="x" size="14"></vue-feather>
                      </button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- paging winners -->
            <div v-if="winners_total_pages > 1" class="d-flex justify-content-center align-items-center gap-2 py-2">
              <button class="btn btn-sm btn-outline-secondary" :disabled="winners_page === 1" @click="winners_page--">&laquo;</button>
              <span class="small">{{ winners_page }} / {{ winners_total_pages }}</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="winners_page === winners_total_pages" @click="winners_page++">&raquo;</button>
            </div>
          </div>

          <!-- รายชื่อผู้สมัครทั้งหมด (pool ปัจจุบัน) -->
          <div class="card mb-4">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>รายชื่อผู้สมัครที่ยังไม่ถูกสุ่ม ({{ eligible_pool.length }} คน)</b></h5>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ชื่อ-สกุล</th>
                    <th style="text-align: center">เพศ</th>
                    <th style="text-align: left">ประเภท</th>
                    <th style="text-align: center">เบอร์โทร</th>
                  </tr>
                </thead>
                <tbody v-if="eligible_pool.length === 0">
                  <tr>
                    <td colspan="5" class="text-center text-muted">ไม่มีรายชื่อในกลุ่มที่เลือก</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(r, index) in pool_paged" :key="r.runner_id">
                    <td style="text-align: center">{{ (pool_page - 1) * page_size + index + 1 }}</td>
                    <td>{{ r.fname }} {{ r.lname }}</td>
                    <td style="text-align: center">{{ r.sex }}</td>
                    <td>{{ r.run_type_name }}</td>
                    <td style="text-align: center">{{ mask_phone(r.mobile_no) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- paging pool -->
            <div class="d-flex justify-content-center align-items-center gap-2 py-2">
              <button class="btn btn-sm btn-outline-secondary" :disabled="pool_page === 1" @click="pool_page--">&laquo;</button>
              <span class="small">{{ pool_page }} / {{ pool_total_pages }} (แสดง {{ pool_paged.length }} / {{ eligible_pool.length }} รายการ)</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="pool_page === pool_total_pages" @click="pool_page++">&raquo;</button>
            </div>
          </div>

          <!-- รายชื่อผู้สมัครที่ถูกบันทึกเข้าระบบแล้ว -->
          <div class="card mb-4">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>✅ รายชื่อผู้สมัครที่ถูกบันทึกเข้าระบบแล้ว ({{ lucky_saved_list.length }} คน)</b></h5>
                <div class="d-flex gap-2">
                  <button type="button" @click.prevent="load_lucky_saved()" class="btn btn-outline-secondary btn-sm">
                    <vue-feather type="refresh-cw" size="16"></vue-feather> โหลดข้อมูลใหม่
                  </button>
                  <button type="button" @click.prevent="export_winners()" class="btn btn-success btn-sm">
                    <vue-feather type="download" size="16"></vue-feather> Export
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">ลำดับ</th>
                    <th style="text-align: left">ชื่อ-สกุล</th>
                    <th style="text-align: center">เพศ</th>
                    <th style="text-align: left">ประเภท</th>
                    <th style="text-align: center">เบอร์โทร</th>
                  </tr>
                </thead>
                <tbody v-if="is_loading_saved === 'Y'">
                  <tr><td colspan="5" class="text-center">กำลังโหลด...</td></tr>
                </tbody>
                <tbody v-else-if="lucky_saved_list.length === 0">
                  <tr><td colspan="5" class="text-center text-muted">ยังไม่มีรายชื่อที่บันทึก</td></tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(r, index) in lucky_saved_paged" :key="r.id">
                    <td style="text-align: center">{{ (lucky_saved_page - 1) * page_size + index + 1 }}</td>
                    <td>{{ r.fname }} {{ r.lname }}</td>
                    <td style="text-align: center">{{ r.sex }}</td>
                    <td>{{ r.run_type_name }}</td>
                    <td style="text-align: center">{{ mask_phone(r.mobile_no) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center align-items-center gap-2 py-2">
              <button class="btn btn-sm btn-outline-secondary" :disabled="lucky_saved_page === 1" @click="lucky_saved_page--">&laquo;</button>
              <span class="small">{{ lucky_saved_page }} / {{ lucky_saved_total_pages }} (แสดง {{ lucky_saved_paged.length }} / {{ lucky_saved_list.length }} รายการ)</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="lucky_saved_page === lucky_saved_total_pages" @click="lucky_saved_page++">&raquo;</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
import * as XLSX from "xlsx";

export default {
  components: { welcomecard },
  data() {
    return {
      is_authorization: null,
      token: null,
      is_loading: "Y",
      eventDetails: {},

      all_paid_runners: [],  // ผู้สมัครสถานะ PAID ทั้งหมด
      winners: [],           // รายชื่อที่สุ่มได้แล้ว
      drawn_ids: new Set(),  // runner_id ที่ถูกสุ่มแล้ว

      filter_run_type: "",
      filter_sex: "",
      prize_count: 1,

      is_rolling: false,
      rolling_display: "",
      current_winners: [],

      rolling_interval: null,
      is_saving: false,
      is_resetting: false,

      // lucky saved
      lucky_saved_list: [],
      is_loading_saved: "N",

      // paging
      winners_page: 1,
      pool_page: 1,
      lucky_saved_page: 1,
      page_size: 50,
    };
  },
  computed: {
    run_types() {
      const counts = {};
      this.all_paid_runners.forEach((r) => {
        if (r.run_type_name) counts[r.run_type_name] = (counts[r.run_type_name] || 0) + 1;
      });
      return Object.keys(counts).sort().map((name) => ({ name, count: counts[name] }));
    },
    eligible_pool() {
      return this.all_paid_runners.filter((r) => {
        if (this.drawn_ids.has(r.runner_id)) return false;
        if (this.filter_run_type && r.run_type_name !== this.filter_run_type) return false;
        if (this.filter_sex && r.sex !== this.filter_sex) return false;
        return true;
      });
    },
    winners_total_pages() {
      return Math.max(1, Math.ceil(this.winners.length / this.page_size));
    },
    winners_paged() {
      const start = (this.winners_page - 1) * this.page_size;
      return this.winners.slice(start, start + this.page_size);
    },
    pool_total_pages() {
      return Math.max(1, Math.ceil(this.eligible_pool.length / this.page_size));
    },
    pool_paged() {
      const start = (this.pool_page - 1) * this.page_size;
      return this.eligible_pool.slice(start, start + this.page_size);
    },
    lucky_saved_total_pages() {
      return Math.max(1, Math.ceil(this.lucky_saved_list.length / this.page_size));
    },
    lucky_saved_paged() {
      const start = (this.lucky_saved_page - 1) * this.page_size;
      return this.lucky_saved_list.slice(start, start + this.page_size);
    },
  },
  watch: {
    filter_run_type() { this.pool_page = 1; },
    filter_sex() { this.pool_page = 1; },
    winners() { this.winners_page = 1; },
  },
  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    if (this.token !== null) {
      await this.authorization();
      if (this.is_authorization === "Y") {
        await this.getEventDetail();
        await this.load_runners();
        await this.load_lucky_saved();
      }
    } else {
      this.$router.push("/auth/login");
    }
  },
  methods: {
    mask_phone(phone) {
      if (!phone || phone.length < 7) return phone;
      return phone.substring(0, 3) + "XXXX" + phone.substring(phone.length - 3);
    },
    async authorization() {
      const data = { event_key: this.$route.params.event_key };
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/authorization", data, { headers });
      if (res.data.status === "success") {
        this.is_authorization = res.data.message.is_authorization;
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async getEventDetail() {
      const res = await axios.get("/v1/events/initial/" + this.$route.params.event_key);
      if (res.data.status === "success" && res.data.body && res.data.body.length > 0) {
        this.eventDetails = res.data.body[0];
      }
    },
    async load_runners() {
      this.is_loading = "Y";
      const data = {
        event_key: this.$route.params.event_key,
        order_filter_type: "status",
        order_filter_value: "PAID",
      };
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/report-runner-list", data, { headers });
      if (res.data.status === "success") {
        this.all_paid_runners = res.data.body || [];
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_runners");
      }
      this.is_loading = "N";
    },
    async load_lucky_saved() {
      this.is_loading_saved = "Y";
      const data = { event_key: this.$route.params.event_key };
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/report-runner-list-lucky", data, { headers });
      if (res.data.status === "success") {
        this.lucky_saved_list = res.data.body || [];
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้ผู้ดูแลระบบ]: load_lucky_saved");
      }
      this.is_loading_saved = "N";
    },
    start_draw() {
      const pool = [...this.eligible_pool];
      if (pool.length === 0) return;

      const count = Math.min(this.prize_count, pool.length);

      // สุ่มเลือกผู้โชคดีทันที (ก่อน animate)
      const selected = [];
      const pool_copy = [...pool];
      for (let i = 0; i < count; i++) {
        const idx = Math.floor(Math.random() * pool_copy.length);
        selected.push(pool_copy.splice(idx, 1)[0]);
      }

      this.is_rolling = true;
      this.current_winners = [];

      let tick = 0;
      const totalTicks = 30 + Math.floor(Math.random() * 20); // 30-50 ครั้ง
      const speed_start = 60;
      const speed_end = 300;

      const roll = () => {
        // แสดงชื่อสุ่มจาก pool ทั้งหมดระหว่าง animate
        const r = pool[Math.floor(Math.random() * pool.length)];
        this.rolling_display = r.fname + " " + r.lname;
        tick++;

        const progress = tick / totalTicks;
        const delay = speed_start + Math.floor((speed_end - speed_start) * progress * progress);

        if (tick < totalTicks) {
          this.rolling_interval = setTimeout(roll, delay);
        } else {
          // จบการสุ่ม — แสดงผู้โชคดีทั้งหมดพร้อมกัน
          const new_ids = new Set([...this.drawn_ids]);
          selected.forEach((w) => {
            w.prize_name = "รางวัล";
            new_ids.add(w.runner_id);
            this.winners.push({ ...w });
          });
          this.drawn_ids = new_ids;
          this.current_winners = selected;
          this.is_rolling = false;
        }
      };

      roll();
    },
    remove_winner(index) {
      const w = this.winners[index];
      this.drawn_ids.delete(w.runner_id);
      this.drawn_ids = new Set([...this.drawn_ids]); // trigger reactivity
      this.winners.splice(index, 1);
      this.current_winners = this.current_winners.filter((c) => c.runner_id !== w.runner_id);
    },
    reset_draw() {
      if (this.is_rolling) {
        clearTimeout(this.rolling_interval);
        this.is_rolling = false;
      }
      this.winners = [];
      this.drawn_ids = new Set();
      this.current_winners = [];
      this.rolling_display = "";
    },
    async reset_lucky_draw() {
      if (!confirm("ยืนยันรีเซ็ตการสุ่มทั้งหมด? ข้อมูลที่บันทึกไว้จะถูกล้าง")) return;
      this.is_resetting = true;
      const data = { event_key: this.$route.params.event_key };
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/report-runner-lucky-reset", data, { headers });
      if (res.data.status === "success") {
        this.reset_draw();
        alert("รีเซ็ตการสุ่มสำเร็จ");
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
      this.is_resetting = false;
    },
    async save_lucky_draw() {
      if (this.winners.length === 0) return;
      this.is_saving = true;
      const data = {
        event_key: this.$route.params.event_key,
        lucky_list: this.winners.map((w) => ({
          id: w.id,
          order_uuid: w.order_uuid,
          id_card: w.id_card,
        })),
      };
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/report-runner-lucky-update", data, { headers });
      if (res.data.status === "success") {
        alert("บันทึกข้อมูลการสุ่มสำเร็จ");
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
      this.is_saving = false;
    },
    export_winners() {
      if (this.lucky_saved_list.length === 0) return;
      const header = ["ลำดับ", "id", "order_uuid", "เลขบัตรประชาชน", "ชื่อ", "สกุล", "เพศ", "สัญชาติ", "วันเกิด", "อายุ", "เบอร์โทร", "ประเภท", "ขนาดเสื้อ", "รางวัล"];
      const rows = this.lucky_saved_list.map((w, i) => [
        i + 1,
        w.id,
        w.order_uuid,
        w.id_card,
        w.fname,
        w.lname,
        w.sex,
        w.nationality,
        w.dob ? w.dob.substring(0, 10) : "",
        w.age,
        w.mobile_no,
        w.run_type_name,
        w.t_shirt_name,
        w.prize_name,
      ]);
      const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ผู้โชคดี");
      XLSX.writeFile(wb, `lucky-draw-${this.$route.params.event_key}.xlsx`);
    },
  },
  beforeUnmount() {
    if (this.rolling_interval) clearTimeout(this.rolling_interval);
  },
};
</script>

<style scoped>
.lucky-draw-box {
  min-height: 180px;
  border: 3px solid #e9ecef;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  transition: border-color 0.3s, background 0.3s;
}

.lucky-draw-box.is-rolling {
  border-color: #007bff;
  background: #e7f1ff;
  animation: pulse-border 0.5s infinite alternate;
}

@keyframes pulse-border {
  from { border-color: #007bff; }
  to   { border-color: #66b2ff; }
}

.lucky-draw-placeholder {
  text-align: center;
  color: #adb5bd;
}

.lucky-draw-rolling {
  text-align: center;
}

.rolling-name {
  font-size: 2rem;
  font-weight: bold;
  color: #007bff;
  letter-spacing: 1px;
}

.lucky-draw-winner {
  text-align: center;
  animation: winner-pop 0.4s ease;
}

@keyframes winner-pop {
  0%   { transform: scale(0.7); opacity: 0; }
  70%  { transform: scale(1.08); }
  100% { transform: scale(1); opacity: 1; }
}

.winner-label {
  font-size: 1.1rem;
  color: #ffc107;
  font-weight: bold;
}

.winner-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.winner-card {
  background: #fff;
  border: 1px solid #28a745;
  border-radius: 6px;
  padding: 4px 8px;
  min-width: 80px;
  text-align: center;
  animation: winner-pop 0.4s ease;
}

.winner-number {
  font-size: 0.65rem;
  color: #adb5bd;
  font-weight: bold;
}

.winner-name-sm {
  font-size: 0.75rem;
  font-weight: bold;
  color: #28a745;
  margin: 2px 0 1px;
}

.winner-detail-sm {
  font-size: 0.65rem;
  color: #6c757d;
}

.winner-name {
  font-size: 2.2rem;
  font-weight: bold;
  color: #28a745;
  margin: 8px 0;
}

.winner-detail {
  font-size: 1rem;
  color: #6c757d;
}

.winner-prize {
  font-size: 1.1rem;
  font-weight: bold;
  color: #fd7e14;
}
</style>
